import React, { useState } from 'react';
import '../../styled/pages/login.scss'; // Ensure the correct path to your SCSS file

interface TemplateNameModalProps {
  isOpen: boolean;
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

const TemplateNameModal: React.FC<TemplateNameModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  const [templateName, setTemplateName] = useState('');
  const [error, setError] = useState<string | null>(null); // State for error message

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (!templateName.trim()) {
      // If template name is empty, show an error message
      setError('Template name is required');
      return;
    }

    // If template name is valid, proceed with confirmation
    onConfirm(templateName);
    setTemplateName(''); // Reset input
    setError(null); // Clear error
  };

  const handleCancel = () => {
    onCancel();
    setTemplateName(''); // Reset input
    setError(null); // Clear error
  };

  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__body text-center">
            <h4 className="title title--h2 title--semibold">Template Name</h4>
            <input
              type="text"
              value={templateName}
              onChange={e => {
                setTemplateName(e.target.value);
                setError(null); // Clear error when user starts typing
              }}
              placeholder="Enter template name"
              className="form__input form__input--patientsearch"
              style={{ margin: '10px 0', width: '80%' }}
            />
            {error && (
              <div
                className="hint error"
                style={{ color: 'red', margin: '5px 0' }}
              >
                {error}
              </div>
            )}
            <div
              className="button-group"
              style={{ marginTop: '15px' }}
            >
              <button
                className="btn btn__secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="btn btn__primary"
                onClick={handleConfirm}
                disabled={!templateName.trim()} // Disable button if template name is empty
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal__backdrop"
        onClick={handleCancel}
      ></div>
    </div>
  );
};

export default TemplateNameModal;
